import axios from "axios";
import apiClient from "../utilities/ApiClient";

const UploadGraphicalViewerImage = async (data) => {
    const res = await apiClient.post("graphical-viewer/image", data, {
        headers: {
            "content-type": "multipart/form-data",
        },
    });

    return res.data;
};

const UploadGraphicalViewerImageColorized = async (data, id) => {
    const res = await apiClient.post(
        `graphical-viewer/colorized-image/${id}`,
        data,
        {
            headers: {
                "content-type": "multipart/form-data",
            },
        }
    );

    window.location.reload();

    return res.data;
};

const UpdateGraphicalViewerImage = async (image_id, data) => {
    const res = await apiClient.put(`graphical-viewer/image/${image_id}`, data);

    return res;
};

const GetGraphicalViewerImages = async (auctionID) => {
    const { data } = await apiClient.get(`graphical-viewer/image/${auctionID}`);

    return data;
};

// TODO: Replace with link to S3
const GetGraphicalViewerImageBuffer = async (imgName) => {
    const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/image/${imgName}`
    );

    return data;
};

const DeleteGraphicalViewerImage = async (imgID) => {
    const res = await apiClient.delete(`graphical-viewer/image/${imgID}`);
    return res;
};

const GraphicalViewerImageService = {
    UploadGraphicalViewerImage,
    GetGraphicalViewerImages,
    GetGraphicalViewerImageBuffer,
    UploadGraphicalViewerImageColorized,
    DeleteGraphicalViewerImage,
    UpdateGraphicalViewerImage,
};

export default GraphicalViewerImageService;
